module.exports = __webpack_public_path__ + "static/media/Concorrencia_por_vaga.b1d59b77.pdf";